export default class AuthMethodEnum {
    static get azure() {
        return "azure";
    }
    static get corIdentity() {
        return "cor-identity";
    }
}
